import Box from '@components/base/Box'
import TextLink from '@components/base/TextLink'
import { formatEventDateTime } from '@libs/Utility/util'
import DefaultThumbnail from '@public/images/default-thumbnail.png'
import { Event } from '@graphql/__generated/graphql'
import Image from 'next/image'

type EventRegistrationHeroProps = {
  event?: Partial<Event>
  dynamicStyle: Record<string, string | number>
  eventImage: string
  isDarkTheme: boolean
  videoUrl: string
}

const EventRegistrationHero = ({
  event,
  dynamicStyle,
  eventImage,
  isDarkTheme,
  videoUrl,
}: EventRegistrationHeroProps) => {
  return (
    <Box
      color="foregroundColour"
      style={dynamicStyle as unknown as {}}
      className="relative px-2 pt-9 pb-9 border-b border-forumm-menu-border"
    >
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover select-none no-controls"
      >
        <source src={videoUrl} type="video/mp4" />
      </video>
      <Box className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0">
        <Box
          className={`rounded-2xl shadow-lg flex p-10 md:p-6 md:py-4 md:pt-6 md:pb-6 w-full md:w-[85%] max-w-[1500px] ${
            isDarkTheme ? '' : 'border border-forumm-menu-border'
          }`}
          color="backgroundColorBanner"
          style={{
            background: isDarkTheme
              ? 'rgba(0, 0, 0, 0.6)'
              : 'rgba(255, 255, 255, 0.6)',
            backdropFilter: 'blur(5px)',
            WebkitBackdropFilter: 'blur(5px)',
          }}
        >
          <Box className="hidden md:flex flex ml-2 items-center">
            <Box className="md:h-[250px] md:w-[250px] w-[250px] h-[240px] md:rounded-2xl rounded-md overflow-hidden flex flex-col justify-start items-center mx-auto md:ml-2">
              <Box
                className="h-full w-full bg-cover bg-center"
                style={{ backgroundImage: `url('${eventImage}')` }}
              ></Box>
            </Box>
          </Box>

          <Box className="md:w-full ml-2 md:ml-20 md:mr-10 ml-0 flex">
            <Box>
              <Box className="flex flex-row items-center mb-2">
                <Image
                  alt="Thumbnail Image"
                  className="h-10 w-10 rounded-full mr-4 object-cover"
                  width={30}
                  height={30}
                  src={event?.event?.thumbnailImage ?? DefaultThumbnail}
                />
                <Box className="flex items-center text-[14px]">
                  {/* <Tooltip id="eventTitleDescription"> */}
                  {event?.event?.organizationName}
                  {/* </Tooltip> */}
                </Box>
              </Box>
              <Box className="text-[36px] w-full font-bold">
                {event?.event?.title}
              </Box>
              <Box className="mb-6" style={{ whiteSpace: 'pre-wrap' }}>
                <TextLink className="text-[16px] md:text-[16px] mt-4 mb-4">
                  {event?.event?.shortDescription}
                </TextLink>
              </Box>

              {/* Event Dates */}
              <Box className="flex mb-4">
                <Box className="flex flex-col space-y-2 mr-4">
                  <Box className={`text-md font-medium`}>Start Time/Date</Box>
                  <Box className="text-xs md:text-sm">
                    {formatEventDateTime(
                      event?.event?.startDateTime,
                      'MMM DD, h:mm A',
                      event?.event
                    )}
                  </Box>
                </Box>
                <Box className="flex flex-col space-y-2">
                  <Box className={`text-md font-medium`}>End Time/Date</Box>
                  <Box className="text-xs md:text-sm">
                    {formatEventDateTime(
                      event?.event?.endDateTime,
                      'MMM DD, h:mm A',
                      event?.event
                    )}
                  </Box>
                </Box>
              </Box>
              <Box className="mt-4 text-xs md:text-sm">
                Having trouble? Email{' '}
                <a className="underline" href="mailto:hello@forumm.to">
                  hello@forumm.to
                </a>
                .
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EventRegistrationHero
